export default "__VITE_ASSET__BFxOmxAX__"